import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M8 9l3 3l-3 3","key":"svg-0"}],["path",{"d":"M13 15l3 0","key":"svg-1"}],["path",{"d":"M3 6a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2l0 -12","key":"svg-2"}]]

const IconTerminal2 = createReactComponent('outline', 'terminal-2', 'Terminal2', __iconNode);

export default IconTerminal2;